// src/views/PickupInfo.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PickupInfo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { customer, cart, subtotal, envio, total, orderId, pickupCode } =
    location.state || {};

  if (!customer) {
    navigate("/");
    return null;
  }

  const handleComplete = () => {
    console.log("Pago final recibido y pedido completado", orderId);
    alert("Pedido marcado como completado.");
    navigate("/");
  };

  return (
    <div
      className="relative flex items-center justify-center min-h-screen bg-white"
      style={{ fontFamily: '"Plus Jakarta Sans", "Noto Sans", sans-serif' }}
    >
      <div className="w-full md:w-[512px] max-w-[960px] p-6 flex flex-col gap-6">
        <div className="text-center">
          <p className="text-[#181111] text-[32px] font-bold">
            Recogida del producto
          </p>
          <p className="text-gray-600 text-sm mt-1">Pedido ID: {orderId}</p>
        </div>

        {/* Código de recogida */}
        <div className="text-center">
          <h3 className="text-[#181111] text-lg font-bold pb-2 pt-4">
            Código de recogida
          </h3>
          <div className="bg-gray-100 border border-gray-300 rounded-lg p-4 font-bold text-xl text-gray-800 inline-block">
            {pickupCode || "ABC123"}
          </div>
          <p className="text-gray-600 text-sm mt-2">
            Presente este código en la agencia para recoger su pedido.
          </p>
        </div>

        {/* Resumen del pedido */}
        <div>
          <h3 className="text-[#181111] text-lg font-bold pb-2 pt-4 text-center">
            Resumen del pedido
          </h3>
          <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
            {cart.map((item) => (
              <div
                key={item.name}
                className="flex justify-between py-2 text-sm text-gray-600"
              >
                <p>
                  {item.quantity} x {item.name}
                </p>
                <p>${(item.quantity * item.price).toFixed(2)}</p>
              </div>
            ))}
            <div className="flex justify-between py-2">
              <p className="text-sm text-gray-600">Envío</p>
              <p className="text-sm">${envio.toFixed(2)}</p>
            </div>
            <div className="flex justify-between py-2 font-bold">
              <p className="text-sm">Total pendiente</p>
              <p className="text-sm">${total.toFixed(2)}</p>
            </div>
          </div>
        </div>

        {/* Botón para completar */}
        <div className="flex justify-center">
          <button
            onClick={() =>
                navigate("/confirmacion-pedido", {
                state: {
                    order: {
                    id: orderId,
                    products: cart.map((item) => item.name),
                    total: total,
                    },
                },
                })
            }
            className="rounded-lg h-12 px-5 bg-red-600 text-white font-bold hover:bg-red-700"
            >
            Pago final recibido / Pedido completado
            </button>
        </div>
      </div>
    </div>
  );
};

export default PickupInfo;
